// extracted by mini-css-extract-plugin
export default {"activedfdf":"Navbar_activedfdf__wJChu","active":"Navbar_active__7Hx+n"};